import Configuration from '@/views/configuration/Configuration.vue'

const router = {
    path: '/configuration',
    name: 'Configuration',
    component: Configuration,
    meta: {
        title: 'Configuration'
    }
};

export default router
